import React from 'react';
import { useSelector } from 'react-redux';

import { useTranslation } from '@common/hooks/translation';
import Config from '@app/dev/config/main';

const ClientTransactionAdminConfirm = () => {
  const t = useTranslation();

  const isAdminLoggedIn = useSelector((state) => state.terminal.isAdminLoggedIn);

  if (isAdminLoggedIn || Config.enableClientTransactionWithoutAdmin) return null;

  return (
    <p className="ct-admin-confirm">
      <i className="global-icon icon-login-admin " />
      {t('Please ask administration for confirmation')}
    </p>
  );
};

export default ClientTransactionAdminConfirm;
